import styles from './channelCardStrip.module.scss';

const { badgeStyles } = styles;

export function ChannelBadge({ badgeText, className }: { badgeText: string; className?: string }) {
    return <div className={`${badgeStyles} ${className}`}>{badgeText}</div>;
}
